// Kalendář: typované funkce nad api() podle smlouvy v packages/shared/src/events.ts.
import type {
  CreateEventInput,
  EventItem,
  EventMutationResponse,
  EventWarning,
  OrgMember,
  UpdateEventInput,
} from '@wac-buddy/shared'
import { api } from './client'
import { buildQuery } from './query'

export interface ListEventsParams {
  from: string
  to: string
  assigneeId?: string
  jobId?: string
  clientId?: string
}

export async function listEvents(params: ListEventsParams): Promise<EventItem[]> {
  const res = await api<{ data: EventItem[] }>(
    `/events${buildQuery({
      from: params.from,
      to: params.to,
      assigneeId: params.assigneeId,
      jobId: params.jobId,
      clientId: params.clientId,
    })}`,
  )
  return res.data
}

export interface ConflictParams {
  startAt: string
  endAt: string
  assigneeId?: string
  excludeId?: string
}

export async function listConflicts(params: ConflictParams): Promise<EventWarning[]> {
  const res = await api<{ data: EventWarning[] }>(
    `/events/conflicts${buildQuery({
      startAt: params.startAt,
      endAt: params.endAt,
      assigneeId: params.assigneeId,
      excludeId: params.excludeId,
    })}`,
  )
  return res.data
}

export function getEvent(id: string): Promise<EventItem> {
  return api(`/events/${encodeURIComponent(id)}`)
}

export function createEvent(input: CreateEventInput): Promise<EventMutationResponse> {
  return api('/events', { method: 'POST', body: JSON.stringify(input) })
}

export function updateEvent(id: string, input: UpdateEventInput): Promise<EventMutationResponse> {
  return api(`/events/${encodeURIComponent(id)}`, { method: 'PATCH', body: JSON.stringify(input) })
}

export function deleteEvent(id: string): Promise<void> {
  return api(`/events/${encodeURIComponent(id)}`, { method: 'DELETE' })
}

export async function listMembers(): Promise<OrgMember[]> {
  const res = await api<{ data: OrgMember[] }>('/org/members')
  return res.data
}
